// Tabination Setup
function openBrandTab(event, tabName) {

    sessionStorage.setItem('tabName', tabName);
    let targetElement = event.target;
    let LinkURL = targetElement.dataset.href;
    window.location.href = LinkURL;
}

const currentTemplate =  window.globalVariables.template;
const currentTemplateSuffix =  window.globalVariables.templateSS;
if(currentTemplateSuffix == "wrestle-boutique") {
    sessionStorage.setItem('tabName', 'WB');
}else if(currentTemplateSuffix == "nidrogen") {
    sessionStorage.setItem('tabName', 'Nidrogen');
}else if(currentTemplate == "index") {
    sessionStorage.setItem('tabName', 'FFB');
}
let getTab = sessionStorage.getItem("tabName");
if(getTab != null && getTab != "") {
    let tabcontent = document.querySelectorAll(".tablinks");
    let getTab = sessionStorage.getItem("tabName").toLowerCase();
    tabcontent.forEach(el => {
        el.classList.remove("active");
    });
    document.body.classList.add(`${getTab}_brand_class`);
    document.querySelector(`.tab_${getTab}`).classList.add("active");
}

// Progress Bar for flickity sliders

setTimeout(()=>{
  let all_flickity_sliders = document.querySelectorAll('.featured-collection'); 
  for(let i=0; i<all_flickity_sliders.length; i++){
    var flkty = new Flickity(all_flickity_sliders[i]);
    
    flkty.on( 'scroll', function( progress ) {
      var progressBar = all_flickity_sliders[i].closest('.featured-collection-section').querySelector('.progress-bar')
      progress = Math.max( 0, Math.min( 1, progress ) );
      progressBar.style.width = progress * 100 + '%';
    });
  }
},2000)

setTimeout(()=>{
  let all_flickity_sliders = document.querySelectorAll('.product-recommendation'); 
  for(let i=0; i<all_flickity_sliders.length; i++){
    var flkty = new Flickity(all_flickity_sliders[i]);
    
    flkty.on( 'scroll', function( progress ) {
      var progressBar = all_flickity_sliders[i].closest('.product-recommendation-main').querySelector('.progress-bar')
      progress = Math.max( 0, Math.min( 1, progress ) );
      progressBar.style.width = progress * 100 + '%';
    });
  }
},2000)

// setting collection url with filters on archive menu item
var brand = sessionStorage.getItem('tabName');
let vault_items = document.querySelectorAll('[data-navlink-handle="the-vault"]');
let brand_filter = document.querySelectorAll('.brand__inner_content');
if(vault_items.length > 0){
  if(brand == "FFB"){
    // vault_items[0].querySelector('a').setAttribute('href', '/collections/the-archive?filter.p.vendor=Funky+Flickr+Boyz');
    if(brand_filter.length > 0){
      brand_filter[0].querySelector('[filter="ffb-archive"]').classList.add('active');
    }
  }
  else if(brand == "WB"){
    console.log("In WB");
    // vault_items[0].querySelector('a').setAttribute('href', '/collections/the-archive?filter.p.vendor=Wrestle+Boutique');
    if(brand_filter.length > 0){
      brand_filter[0].querySelector('[filter="wb-archive"]').classList.add('active');
    }
  }
}
if(brand_filter.length > 0){
  let brand_links = brand_filter[0].querySelectorAll('a');
  brand_links.forEach((brand_item)=> {
    brand_item.addEventListener('click', ()=> {
      if(brand_item.getAttribute('filter') == 'wb-archive'){
        sessionStorage.setItem('tabName' , 'WB')
      }
      else if(brand_item.getAttribute('filter') == 'ffb-archive'){
        sessionStorage.setItem('tabName' , 'FFB')
      }
    })
  })
}

// Setting logo url for mobile
function setting_mobile_logo(mobile_logo_items, logo_url){
  mobile_logo_items.forEach(logo => {
    logo.setAttribute('href', logo_url)
  })
}
let mobile_logo = document.querySelectorAll('.mobile-header__logo');
if(mobile_logo.length > 0){
  if(getTab == 'WB'){
    setting_mobile_logo(mobile_logo, '/pages/wrestle-boutique');
  }
  else if(getTab == 'Nidrogen'){
    setting_mobile_logo(mobile_logo, '/pages/nidrogen');
  }
  else if(getTab == 'FFB'){
    setting_mobile_logo(mobile_logo, '/');
  }
}

